<template>
	<div class="notice">
		<!--公告详情 -->
		<b-modal id="noticetableTab.noticeModel" v-model="noticetableTab.noticeModel.show" title="公告"
			no-close-on-backdrop>
			<div>
				<h4 class="title">{{noticetableTab.noticeModel.title}}</h4>
				<p class="time">{{noticetableTab.noticeModel.createTime}}</p>
				<p class="content">{{noticetableTab.noticeModel.content}}</p>
			</div>
			<template slot="modal-footer">
				<b-button style="display: none;border-bottom: none;border-top: none;">
				</b-button>
			</template>
		</b-modal>
		<!-- 公告列表 -->
		<b-spinner variant="success" class="spinStyle" v-show="showSpin" label="Text Centered"></b-spinner>
		<b-table id="notice-table" class="notice-table-info" :fields="noticetableTab.noticeFields"
			:items="noticetableTab.NoticeList" small bordered hover show-empty empty-text="没有找到匹配的记录" caption-top
			:busy="noticetableTab.isTableBusy">
			<template v-slot:cell(actionButton)="row">
				<a href="#" class="notice-table-more" v-on:click="showOrderNotice(row)">查看详情</a>
			</template>
		</b-table>
		<!-- 页码 -->
		<!-- <div class="pageControl">
			<b-pagination v-model="noticetableTab.noticeSearch.limit.conditions.pageStart" style="margin-top:20px;"
				:total-rows="noticetableTab.noticeSearch.limit.conditions.total"
				:per-page="noticetableTab.noticeSearch.limit.conditions.pageLength" align="center" size="sm"
				ellipsis-text="..." first-text="首页" prev-text="上一页" next-text="下一页" last-text="尾页" limit="10"
				@change="onNoticePageChange"></b-pagination>
		</div> -->
	</div>
</template>

<script>
	import api from '@/api/api';
	import search from '@/libs/search';
	import HttpRequest from '@/libs/axios';
	import {
		formatDateTimeString,
		numberToFixed
	} from "@/libs/utils";

	export default {
		name: 'Notice',
		data() {
			return {
				showSpin: false,
				noticetableTab: {
					noticeFields: [{
							key: 'title',
							label: '标题'
						},
						{
							key: 'content',
							label: '内容',
						},
						{
							key: 'createTime',
							label: '发布时间',
						},
						{
							key: 'actionButton',
							label: '操作'
						}
					],
					NoticeList: [],
					noticeModel: {
						show: false,
						title: '',
						content: '',
						createTime: ''
					},
					isTableBusy: false,
					noticeSearch: search.getSearchParams(),
				}
			}
		},
		mounted() {
			this.getNoticeList();
		},
		methods: {
			// 查看详情 ：获取公告详情数据
			showOrderNotice(row) {
				Object.assign(this.noticetableTab.noticeModel, row.item);
				this.noticetableTab.noticeModel.title = row.item.title;
				this.noticetableTab.noticeModel.content = row.item.content;
				this.noticetableTab.noticeModel.createTime = row.item.createTime;

				this.noticetableTab.noticeModel.show = true;
			},
			// 引用页面组件发布时间方法
			formatDateTimeString,
			// 获取公告列表数据
			// onNoticePageChange(pageNum) {
			// 	search.globalPageOnChange(this.noticetableTab.noticeSearch, pageNum);
			// 	this.getNoticeList();
			// },
			// 富文本格式
			get_web_html(richtext) {
				let content = richtext.replace(/<.+?>/g, '');
				content = content.replace(/ /ig, ''); /* 去除  */
				content = content.replace(/\s/ig, ''); /* 去除空格 */
				return content;
			},
			getNoticeList() {
				api.getNoticeList({
					noticeType: '公告'
				}).then(res => {
					if (res.code === 0) {
						if (res.data != null && res.data != '') {
							res.data.forEach(e => {
								e.createTime = this.formatDateTimeString(e.createTime);
								e.content = this.get_web_html(e.content); //富文本格式
							});
							this.noticetableTab.NoticeList = res.data;
							search.globalSetFilterRecordCount(this.noticetableTab.noticeSearch, res.data
								.filterRecordCount);
						}
					}
				});
			},
		}
	}
</script>
<style>
	.notice {
		margin-top: 20px;
		text-align: center;
	}

	.notice thead {
		background-color: rgba(0, 0, 0, .03);
	}

	.notice-table-more {
		color: #1da25a;
		text-decoration: none;
	}

	.notice-table-more:hover {
		color: #1da25a;
	}

	.page-item.active .page-link {
		background-color: #1da25a;
		border: 1px solid #1da25a;
	}

	.modal-header {
		background-color: #1da25a;
		color: #fff;
	}

	.content {
		margin-top: 0px !important;
		display: contents;
	}

	.notice-table-info {
		border-collapse: collapse;
		width: 96%;
		margin: 0.2%;
		table-layout: fixed;
	}

	.notice-table-info tr td {
		width: 100%;
	}

	.notice-table-info tr td {
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		word-wrap: break-word;
	}

	.notice-table-info tr td:nth-child(1) {
		width: 25%;
	}
	.notice-table-info tr td:nth-child(2){
		width: 45%;
	}
	.notice-table-info tr td:nth-child(3){
		width: 20%;
	}
	.notice-table-info tr td:nth-child(4){
		width: 10%;
	}

	/* .notice-table-info tr td:nth-child(even){line-height: 40px;} */
</style>



// WEBPACK FOOTER //
// src/view/notice/notice.vue